import { DataTable, LoadingIndicator } from '@commenda/kakashi';
import { NumberFormat } from '@commenda/utils';
import { CorporationType, Prisma } from '@prisma/client';
import { useOwnershipInfo } from './useOwnershipInfo';

const ShareholdersTable = ({
  businessEntityId,
}: {
  businessEntityId: number;
}) => {
  const {
    isLoading: isOwnershipDataLoading,
    error: ownershipDataError,
    shareholdersInformation,
    businessEntity,
  } = useOwnershipInfo({ businessEntityId });

  const businessEntityType = businessEntity?.businessEntityType;

  if (isOwnershipDataLoading) {
    if (ownershipDataError) console.error(ownershipDataError);

    return (
      <div className="flex flex-col gap-2xl">
        <h3 className="txt-large-bold">
          {businessEntityType === CorporationType.LLC
            ? 'Members'
            : 'Shareholders'}
        </h3>
        <LoadingIndicator size={48} _className="mx-auto" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2xl">
      <h3 className="txt-large-bold">
        {businessEntityType === CorporationType.LLC
          ? 'Members'
          : 'Shareholders'}
      </h3>
      <DataTable
        data={shareholdersInformation}
        rowDataAttributes={() => ({ 'data-ai-item': 'Shareholder' })}
        emptyStateConfig={{
          title: 'No shareholders found.',
          description: 'There are no shareholders in the entity.',
        }}
        columnGroups={[
          {
            id: 'shareholders',
            columns: [
              {
                id: 'name',
                accessorFn: () => null,
                accessorKey: 'name',
                header:
                  businessEntityType === CorporationType.LLC
                    ? 'Member name'
                    : 'Shareholder name',
                cell: ({ row }) => (
                  <div className="flex flex-col py-xl px-2xl">
                    <span className="txt-small-medium">
                      {row.original.name}
                    </span>
                    <span className="txt-small-regular text-text-tertiary">
                      {row.original.email || ' '}
                    </span>
                  </div>
                ),
              },
              {
                id: 'noOfShares',
                accessorFn: () => null,
                accessorKey: 'noOfShares',
                header:
                  businessEntityType === CorporationType.LLC
                    ? 'Contribution amount'
                    : 'No. of shares',
                cell: ({ row }) => (
                  <span className="txt-small-medium">
                    {NumberFormat.formatNumberWithCommas(
                      row.original.noOfShares
                    )}
                  </span>
                ),
              },
              {
                id: 'percentage',
                accessorFn: () => null,
                accessorKey: 'percentage',
                header:
                  businessEntityType === CorporationType.LLC
                    ? 'Contribution percentage'
                    : 'Percentage of shares issued',
                cell: ({ row }) => (
                  <span className="txt-small-medium">
                    {row.original.percentage
                      ? `${new Prisma.Decimal(row.original.percentage).toFixed(4)}%`
                      : '---'}
                  </span>
                ),
              },
            ],
          },
        ]}
      />
    </div>
  );
};

export { ShareholdersTable };
